const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.TrainerServiceSimpleClient = function TrainerServiceSimpleClient(
  hostname,
  credentials,
  options
) {
  if (!options) options = {};
  options["format"] = "text";

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  this.hostname_ = hostname;
  this.credentials_ = credentials;
  this.options_ = options;

  this.getTrainer = this.getTrainer.bind(this);
  this.listTrainers = this.listTrainers.bind(this);
};
const methodInfo_TrainerService_GetTrainer = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.TrainerService/GetTrainer",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.GetTrainerRequest,
  imports.stronachgroup.first.racehorse360.Trainer,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.Trainer.decode
);
module.exports.TrainerServiceSimpleClient.prototype.getTrainer = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.GetTrainerRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.TrainerService/GetTrainer",
    message,
    metadata || {},
    methodInfo_TrainerService_GetTrainer
  );
};
const methodInfo_TrainerService_ListTrainers = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.TrainerService/ListTrainers",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListTrainersRequest,
  imports.stronachgroup.first.racehorse360.ListTrainersResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListTrainersResponse.decode
);
module.exports.TrainerServiceSimpleClient.prototype.listTrainers = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListTrainersRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.TrainerService/ListTrainers",
    message,
    metadata || {},
    methodInfo_TrainerService_ListTrainers
  );
};
